import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import Navbar from './Navbar'

export default function NavbarComponent() {
    const [isActive, setIsActive] = useState(false)
    return (
        <div className="flex">
            <motion.button
                className="relative z-50 flex h-10 w-8 cursor-pointer flex-col items-center justify-center gap-2 rounded-full border-0 bg-transparent outline-none"
                onClick={() => setIsActive((prev) => !prev)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
            >
                <motion.div
                    id="burger"
                    initial={{ rotate: 0 }}
                    animate={{ rotate: isActive ? 45 : 0, y: isActive ? 5 : 0 }}
                    transition={{ duration: 0.2 }}
                    className="h-[2px] w-full bg-white"
                ></motion.div>
                <motion.div
                    id="burger"
                    initial={{ rotate: 0 }}
                    animate={{ rotate: isActive ? -45 : 0, y: isActive ? -5 : 0 }}
                    transition={{ duration: 0.2 }}
                    className="h-[2px] w-full bg-white"
                ></motion.div>
            </motion.button>
            <AnimatePresence mode="wait">
                {isActive && (
                    <>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setIsActive(false)}
                            className="fixed inset-0 z-30 h-screen w-screen cursor-pointer bg-black/50"
                        ></motion.div>
                        <Navbar handleClose={() => setIsActive(false)} />
                    </>
                )}
            </AnimatePresence>
        </div>
    )
}
